var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41421 3C6.88378 3 6.37507 3.21071 6 3.58579L3.58579 6C3.30991 6.27588 3.12295 6.62406 3.04336 7H20.9566C20.8771 6.62406 20.6901 6.27588 20.4142 6L18 3.58579C17.6249 3.21071 17.1162 3 16.5858 3H7.41421ZM21 9H3V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9ZM12 11C12.5523 11 13 11.4477 13 12V15.1858L13.4142 14.7715C13.8047 14.381 14.4379 14.381 14.8284 14.7715C15.219 15.1621 15.219 15.7952 14.8284 16.1858L12.7071 18.3071C12.3166 18.6976 11.6834 18.6976 11.2929 18.3071L9.17157 16.1858C8.78105 15.7952 8.78105 15.1621 9.17157 14.7715C9.5621 14.381 10.1953 14.381 10.5858 14.7715L11 15.1858V12C11 11.4477 11.4477 11 12 11Z",
    fill: "#15803D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.64043d7ccd5dd85be7d88cb9092d5d3f.svg";
export { ForwardRef as ReactComponent };